import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchPublishedProjects, fetchPublishedProjectsTotal } from '@app/api'

import { getUserLanguage } from '@app/utils'

import { DEFAULT_LISTINGS_SORTING, ListingsSorting } from '@lib/components'

export const getPublishedProjectsThunk = createAsyncThunk(
  'publishedProjects/fetch',
  async ({
    skip = 0,
    count,
    search,
    transactionType,
    sort = DEFAULT_LISTINGS_SORTING,
  }: {
    skip?: number
    count?: number
    search?: string
    transactionType?: string
    sort?: ListingsSorting
  } = {}) => {
    const userLanguage = getUserLanguage()

    const { projects, total } = await fetchPublishedProjects(
      userLanguage,
      'Puzzle',
      count,
      skip,
      search,
      transactionType,
      sort
    )

    return {
      projects,
      skip,
      count,
      search,
      transactionType,
      sort,
      total,
    }
  }
)

export const getPublishedProjectsTotalThunk = createAsyncThunk(
  'publishedProjects/fetchTotal',
  async () => {
    const total = await fetchPublishedProjectsTotal()

    return total
  }
)
